import {API_POST_METHOD, API_PUT_METHOD, API_GET_METHOD} from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';
import { axiosLabAPI } from 'services/axios';

export async function createUserAccountAPI(payload) {
	let createUserAccount = {};

  try {

    const content = {
      method: API_POST_METHOD,
      url: `settings/useraccount`,
      data: payload
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    if (data && data.STATUSCODE === 200) {
      createUserAccount = {
        data: data.RECORDS,
        status: 201, // Return 201 for successful creation
      };
    }
  }
  catch (e) {
    showMessage(e);
  }

	
  return createUserAccount;
}

export async function updateUserAccountAPI(payload) {
	let updateUserAccount = {};
	
  try {
    const content = {
      method: API_PUT_METHOD,
      url: `settings/useraccount`,
      data: payload
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    if (data && data.STATUSCODE === 200) {
      updateUserAccount = {
        data: data.RECORDS,
        status: 200, // Return 200 for successful update
      };
    }
  }
  catch (e) {
    showMessage(e);
  }

	
  return updateUserAccount;
}

export async function getUserAccountsAPI(){
  let getUserAccounts = {
    data: [],
    status: null
  };
	
  try{
    const content = {
      method: API_GET_METHOD,
      url: `settings/useraccount`
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    if (data && data.STATUSCODE === 200 && data.RECORDS) {
      getUserAccounts = {
        data: data.RECORDS,
        status: data.STATUSCODE
      };
    }

  } 
  catch(e) {
    showMessage(e);

	}
  return getUserAccounts;

}

export async function getUserAccountById(id){
  let userAccount = {
    data: [],
    status: null
  };

  try{
    const content = {
      method: API_GET_METHOD,
      url: `settings/useraccount?p_login_user_id${id}`
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    if (data && data.STATUSCODE === 200 && data.RECORDS) {
      userAccount = {
        data: data.RECORDS,
        status: data.STATUSCODE
      };
    }
  }
  catch(e) {
    showMessage(e);

	}
  return userAccount;

}

export async function unblockUserAccountAPI(userid) {
  let unblockResult = {};

  try {
    const content = {
      method: API_PUT_METHOD,
      url: `settings/useraccountunblock`,
      data: { userid }
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    if (data && data.STATUSCODE === 200) {
      unblockResult = {
        data: data.RECORDS,
        status: 200,
        message: data.MESSAGE || 'User unblocked successfully'
      };
    }
  }
  catch (e) {
    showMessage(e);
  }

  return unblockResult;
}

export async function changePasswordAPI(userid, oldPassword, newPassword) {
  let changePasswordResult = {};

  try {
    const content = {
      method: API_PUT_METHOD,
      url: `settings/useraccountchangepassword`,
      data: {
        userid: userid,
        old_password: oldPassword,
        new_password: newPassword
      }
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    if (data && data.STATUSCODE === 200) {
      changePasswordResult = {
        data: data.RECORDS,
        status: 200,
        message: data.MESSAGE || 'Password changed successfully'
      };
    }
  }
  catch (e) {
    showMessage(e);
  }

  return changePasswordResult;
}